import React, { useEffect, useState } from 'react';
import {
  Box,
  Loader,
  Text,
  Layout,
  Spacer,
  Button,
} from '@flexisaf/flexibull2';
import { useRouteMatch, useLocation, useHistory } from 'react-router-dom';
import urls from 'utils/config';
import UserVerified from 'assets/images/verified.svg';
import UserNotVerified from 'assets/images/not-verified.svg';
import request from 'utils/request';
const { API_BASE_URL } = urls || {};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function ConfirmUser() {
  const [isVerified, setIsVerified] = useState(false);
  const [failedVerification, setFailedVerification] = useState(false);
  const history = useHistory();
  const { params } = useRouteMatch();
  const query = useQuery();

  const verifyUser = async () => {
    const url = `${API_BASE_URL}/ums/confirm`;
    const data = {
      organisation: params.orgName,
      userId: query.get('user'),
      token: query.get('token'),
    };

    try {
      const response = await request({ method: 'post', data, url });
      if (response.success) {
        setIsVerified(true);
      }
      setFailedVerification(true);
    } catch (error) {
      setFailedVerification(true);
    }
  };

  useEffect(() => {
    verifyUser();
    // eslint-disable-next-line
  }, []);

  if (isVerified)
    return (
      <Layout>
        <Box width="100%" vAlign height="99vh">
          <Box width="100%" align="center">
            <img src={UserVerified} alt="verified" />
            <Box margin="30px auto" maxWidth="300px">
              <Text block bold size="18px">
                Verification Successful
              </Text>
              <Spacer space="15px" />
              <Text block>
                {' '}
                Your email account has been verified successfully,
                Login to your account to continue.
              </Text>
              <Spacer space="30px" />
              <Button
                onClick={() => history.push(`/${params.orgName}`)}
                width={150}
                height={45}
                bold
              >
                Log in
              </Button>
            </Box>
          </Box>
        </Box>
      </Layout>
    );

  if (failedVerification)
    return (
      <Layout>
        <Box width="100%" vAlign height="99vh">
          <Box width="100%" align="center">
            <img src={UserNotVerified} alt="Not verified" />
            <Box margin="30px auto" maxWidth="300px">
              <Text block bold size="18px">
                Unable to verify user
              </Text>
              <Spacer space="15px" />
              <Text block>
                {' '}
                Your email account could not be verified, you can contact your
                account admin or support for more enquiries.
              </Text>
              <Spacer space="30px" />
              <Button pale width={200} height={45} bold>
                Contact Support
              </Button>
            </Box>
          </Box>
        </Box>
      </Layout>
    );

  return (
    <Box width="100%" height="calc(100vh - 200px)" vAlign>
      <Box width="100%" align="center">
        <Loader />
      </Box>
    </Box>
  );
}
